// - **Purpose**: The component is designed to display a `StoreFinder` UI by extracting store data from the passed `StoreData` object.
// - **Data Access**: It retrieves store data using destructuring from `data` passed as a prop, specifically targeting `channel.body.results` in the `StoreData` object.
// - **Conditional Rendering**: The component checks if `storeData` exists before rendering the `StoreFinder` component. If no store data is available, it returns an empty fragment (`<></>`), effectively rendering nothing.
// - **Child Component**: It passes the `storeData` to the `StoreFinder` component as a prop, which likely uses it to display a list of stores or locations.
// - **TypeScript Usage**: The `data` prop is typed as `StoreData`, ensuring type safety for the incoming store data.

'use client';

import StoreFInder from 'components/commercetools-ui/organisms/StoreFinder';
import React from 'react';
import { ContentItem, FindStoreData } from 'shared/types/product/store';
import { FrontasticImage } from 'frontastic/lib/image';
import { TasticProps } from '../types';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { tablet } from 'helpers/utils/screensizes';

interface InStoreServiceCard {
  title?: string;
  description?: string;
  imageUrl?: FrontasticImage;
  ctaLink?: string;
  ctaName?: string;
}

const transformContentToServiceCards = (content: ContentItem[]): InStoreServiceCard[] => {
  return content.map((item) => ({
    title: item.title || undefined,
    description: item?.description,
    imageUrl: item?.imageUrl,
    ctaLink: item?.ctaLink,
    ctaName: item?.ctaName,
  }));
};

interface FindStoreTasticData {
  data: {
    dataSourceId: string;
    dataSource: {
      channel: any[];
      p1BadgeData?: {
        productListingContent?: any[];
      };
      storeIconsAndBadgesData?: {
        icons?: any[];
        stores?: any[];
      };
      storeTimingsData?: any;
    };
  };
  content: ContentItem[];
}

const FindStoreTastic: React.FC<TasticProps<FindStoreTasticData>> = ({ data }) => {
  console.log('FindStoreTastic data:', data);
  const storeData = data?.data?.dataSource?.channel;
  const cardData = data?.content ? transformContentToServiceCards(data?.content) : [];
  const badges = data?.data?.dataSource?.p1BadgeData?.productListingContent || [];
  const icons = data?.data?.dataSource?.storeIconsAndBadgesData?.icons || [];
  const amplienceStores = data?.data?.dataSource?.storeIconsAndBadgesData?.stores || [];
  const storeTimingsData = data?.data?.dataSource?.storeTimingsData || {};
  const [isTablet] = useMediaQuery(tablet);

  if (!storeData) {
    return <></>;
  }

  return (
    <div className={` mx-auto  max-w-[1866px] ${'px-12 py-16'}`}>
      <StoreFInder
        storeData={storeData}
        cardData={cardData}
        badges={badges}
        icons={icons}
        amplienceStores={amplienceStores}
        storeTimingsData={storeTimingsData}
      />
    </div>
  );
};

export default FindStoreTastic;
